// Central business content for Haya Beauty Care.
// Update facts here only — every component reads from this file.

export const BUSINESS = {
  name: "Haya Beauty Care",
  nameAr: "هيا بيوتي كير",
  phoneDisplay: "+90 534 879 59 85",
  whatsappNumber: "905348795985",
  website: "https://www.hayabeautycare.com/",
  google: { rating: "5.0", reviewCount: 3 },
  // Owner-supplied Google reviewers. Add the real excerpt to `text` to display it; left empty = name + stars only.
  reviews: [
    { name: "Osamah Alawamleh", text: "" },
    { name: "Naila Ramadan", text: "" },
    { name: "Abdullah Edilbi", text: "" },
  ],
  analytics: {
    gaMeasurementId: "", // supply an ID (or REACT_APP_GA_MEASUREMENT_ID) to enable Google Analytics
    metaPixelId: "", // supply an ID (or REACT_APP_META_PIXEL_ID) to enable Meta Pixel
  },
  images: {
    hero: {
      src: "/images/brand/hero-portrait.webp",
      altEn: "Your patient coordination specialist at Haya Beauty Care",
      altAr: "منسّقة رحلات العلاج في هيا بيوتي كير",
    },
    dental: {
      src: "/images/brand/dental-1.jpg",
      altEn: "Smile makeover result, before and after",
      altAr: "نتيجة تجميل الابتسامة، قبل وبعد",
    },
    aesthetic: {
      src: "/images/brand/hair-1.jpg",
      altEn: "Aesthetic hair restoration result, before and after",
      altAr: "نتيجة استعادة الشعر التجميلية، قبل وبعد",
    },
    coordination: {
      src: "https://images.unsplash.com/photo-1623613229313-5e59f698526f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxpc3RhbmJ1bCUyMGJvc3Bob3J1cyUyMHNreWxpbmUlMjBzdW5zZXR8ZW58MHx8fHwxNzg2OTY4NzQ4fDA&ixlib=rb-4.1.0&q=85&w=900&auto=format",
      altEn: "Bosphorus view in Istanbul at sunset",
      altAr: "إطلالة على البوسفور في إسطنبول عند الغروب",
    },
    istanbul: {
      src: "https://images.unsplash.com/photo-1623613229313-5e59f698526f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxpc3RhbmJ1bCUyMGJvc3Bob3J1cyUyMHNreWxpbmUlMjBzdW5zZXR8ZW58MHx8fHwxNzg2OTY4NzQ4fDA&ixlib=rb-4.1.0&q=85&w=1800&auto=format",
      altEn: "Istanbul skyline over the Bosphorus at dusk",
      altAr: "أفق إسطنبول على مضيق البوسفور وقت الغسق",
    },
    results: [
      {
        src: "/images/brand/hair-1.jpg",
        altEn: "Hair restoration, before and after",
        altAr: "استعادة الشعر، قبل وبعد",
      },
      {
        src: "/images/brand/hair-2.jpg",
        altEn: "Hair restoration, before and after",
        altAr: "استعادة الشعر، قبل وبعد",
      },
      {
        src: "/images/brand/dental-1.jpg",
        altEn: "Smile makeover, before and after",
        altAr: "تجميل الابتسامة، قبل وبعد",
      },
      {
        src: "/images/brand/dental-2.jpg",
        altEn: "Full smile restoration, before and after",
        altAr: "ترميم الابتسامة بالكامل، قبل وبعد",
      },
      {
        src: "/images/brand/dental-3.jpg",
        altEn: "Veneers transformation, before and after",
        altAr: "تحوّل الابتسامة بالقشور، قبل وبعد",
      },
    ],
  },
};

export const waLink = (text) =>
  `https://wa.me/${BUSINESS.whatsappNumber}?text=${encodeURIComponent(text)}`;

export const CONTENT = {
  en: {
    brand: { name: BUSINESS.name, tagline: "Patient Coordination · Istanbul" },
    nav: {
      links: [
        { id: "services", label: "Services" },
        { id: "how-it-works", label: "How It Works" },
        { id: "reviews", label: "Reviews" },
        { id: "faq", label: "FAQ" },
        { id: "istanbul", label: "Istanbul" },
        { id: "contact", label: "Contact" },
      ],
      cta: "WhatsApp Consultation",
      switchTo: "العربية",
      menuLabel: "Open menu",
    },
    hero: {
      eyebrow: "Istanbul · International Patient Coordination",
      headlineLines: [
        { text: "Your journey to a" },
        { text: "more confident smile", accent: true },
        { text: "and appearance." },
      ],
      sub: "Haya Beauty Care coordinates your treatment journey in Istanbul — from your first enquiry to your follow-up — with every treatment delivered by independent, licensed healthcare providers.",
      ctaPrimary: "Consult on WhatsApp",
      ctaSecondary: "Explore Services",
      waMessage: "Hello Haya Beauty Care, I would like to request a consultation.",
      ratingTitle: "on Google",
      ratingNote: "Based on the currently displayed Google Business Profile (3 reviews).",
      imageCaption: "Istanbul, Türkiye",
    },
    marquee: [
      "Dental Aesthetics",
      "Plastic Surgery",
      "Patient Coordination",
      "Istanbul",
      "Journey Support",
      "Follow-up Care",
    ],
    services: {
      eyebrow: "What We Coordinate",
      heading: "Care, coordinated beautifully.",
      sub: "Every journey begins with an assessment by a licensed healthcare provider, who determines the treatment that is right for you.",
      items: [
        {
          key: "dental",
          number: "01",
          title: "Dental Treatments",
          text: "Coordination for dental care such as smile aesthetics, veneers, and implants. The appropriate treatment is determined only after assessment by a licensed healthcare provider.",
        },
        {
          key: "aesthetic",
          number: "02",
          title: "Plastic Surgery",
          text: "Coordination for aesthetic and plastic surgery consultations, with a treatment plan prepared by a licensed healthcare provider following your assessment.",
        },
        {
          key: "coordination",
          number: "03",
          title: "International Patient Coordination",
          text: "Appointment scheduling, translation support, travel and stay planning, and continuous follow-up throughout your time in Istanbul.",
        },
      ],
    },
    steps: {
      eyebrow: "How It Works",
      heading: "Four considered steps.",
      items: [
        {
          number: "01",
          title: "Send your request",
          text: "Message us on WhatsApp or complete the consultation form. Tell us, in your own words, what you would like to change.",
        },
        {
          number: "02",
          title: "Initial assessment coordination",
          text: "We coordinate an assessment with a licensed healthcare provider, who reviews your case and recommends the appropriate treatment.",
        },
        {
          number: "03",
          title: "Plan your Istanbul visit",
          text: "We organise your appointments and help shape your travel, so your time in Istanbul feels effortless.",
        },
        {
          number: "04",
          title: "Follow-up",
          text: "After your treatment, we remain your point of contact, coordinating follow-up and aftercare guidance.",
        },
      ],
    },
    reviews: {
      eyebrow: "Google Reviews",
      heading: "What our guests say.",
      note: "Rated 5.0 from 3 reviews, as shown on the currently displayed Google Business Profile.",
      cardLabel: "Google Review",
      reviewsWord: "reviews",
    },
    results: {
      eyebrow: "Real Results",
      heading: "Before & after.",
      sub: "Photographs shared by Haya Beauty Care from real guest journeys.",
      caption: "Before & After",
    },
    faq: {
      eyebrow: "Before You Travel",
      heading: "Questions, answered.",
      sub: "The things our guests ask most before planning their journey to Istanbul.",
      cta: "Ask Us on WhatsApp",
      items: [
        {
          q: "How do I start my journey?",
          a: "Send us a message on WhatsApp or complete the consultation form. We reply personally, listen to what you would like to change, and explain the next steps.",
        },
        {
          q: "Who performs the treatments?",
          a: "All treatments are delivered by independent, licensed healthcare providers. We coordinate your journey, and the appropriate treatment is determined only after a provider assesses your case.",
        },
        {
          q: "Do you help with travel and accommodation?",
          a: "Yes. We organise your appointments and help shape your travel and stay plans, so your time in Istanbul feels effortless.",
        },
        {
          q: "Which languages do you support?",
          a: "We coordinate in Arabic and English, and arrange translation support throughout your visit.",
        },
        {
          q: "When do I receive a price?",
          a: "After a licensed healthcare provider assesses your case and recommends a treatment plan, we share a clear quotation before you make any travel commitment.",
        },
        {
          q: "What happens after my treatment?",
          a: "We remain your point of contact after treatment, coordinating follow-up appointments and aftercare guidance.",
        },
      ],
    },
    istanbul: {
      eyebrow: "The Destination",
      heading: "Istanbul, between two continents.",
      copy: "Your journey unfolds in one of the world's most captivating cities — the Bosphorus at dusk, centuries of history, and hospitality that turns a treatment trip into a memorable escape.",
      cta: "Start Planning",
      waMessage: "Hello Haya Beauty Care, I would like to start planning my visit to Istanbul.",
    },
    form: {
      eyebrow: "Consultation",
      heading: "Begin with a conversation.",
      copy: "Share a few details and we will open a WhatsApp conversation with everything pre-written — no accounts, no waiting rooms.",
      callLabel: "Prefer to talk first?",
      labels: {
        name: "Full name",
        country: "Country",
        phone: "Phone / WhatsApp number",
        service: "Service of interest",
        notes: "Notes (optional)",
      },
      placeholders: {
        name: "Your full name",
        country: "e.g. Jordan",
        phone: "+00 000 000 00 00",
        service: "Select a service",
        notes: "Anything you would like us to know",
      },
      serviceOptions: ["Dental Treatment", "Plastic Surgery", "Other"],
      consent:
        "I consent to Haya Beauty Care contacting me via WhatsApp about my enquiry.",
      sensitiveNote:
        "Please avoid sharing highly sensitive medical information through unsecured channels. Any detailed medical information will be requested later through a secure channel.",
      submit: "Send via WhatsApp",
      toast: "Opening WhatsApp with your message…",
      requiredNote: "Please complete the required fields and consent.",
      messageIntro:
        "Hello Haya Beauty Care, I would like to request a consultation.",
    },
    footer: {
      blurb:
        "International patient coordination for dental treatments and plastic surgery in Istanbul, Türkiye.",
      contactHeading: "Contact",
      legalHeading: "Legal",
      location: "Istanbul, Türkiye",
      privacy: "Privacy Policy",
      cookies: "Cookie Policy",
      policies: {
        privacy: {
          title: "Privacy Policy",
          body: "We collect only the details you choose to share through the consultation form or WhatsApp — such as your name, country, and phone number — and use them solely to respond to your enquiry and coordinate your journey. Submitting the form opens WhatsApp directly in your browser; no form data is stored on our servers. We never sell your personal data.",
        },
        cookies: {
          title: "Cookie Policy",
          body: "This website uses no tracking cookies by default. Analytics tools (Google Analytics and Meta Pixel) remain disabled until measurement IDs are supplied, and all essential site functionality works without cookies.",
        },
      },
      rights: "All rights reserved.",
    },
  },
  ar: {
    brand: { name: BUSINESS.nameAr, tagline: "تنسيق رحلات العلاج · إسطنبول" },
    nav: {
      links: [
        { id: "services", label: "الخدمات" },
        { id: "how-it-works", label: "كيف نعمل" },
        { id: "reviews", label: "آراء Google" },
        { id: "faq", label: "الأسئلة الشائعة" },
        { id: "istanbul", label: "إسطنبول" },
        { id: "contact", label: "تواصل معنا" },
      ],
      cta: "استشارة عبر واتساب",
      switchTo: "EN",
      menuLabel: "فتح القائمة",
    },
    hero: {
      eyebrow: "إسطنبول · تنسيق المرضى الدوليين",
      headlineLines: [
        { text: "رحلتك نحو ابتسامة" },
        { text: "ومظهر أكثر ثقة.", accent: true },
      ],
      sub: "تنسّق «هيا بيوتي كير» رحلة علاجك في إسطنبول — من استفسارك الأول وحتى المتابعة — حيث تُقدَّم جميع العلاجات من قِبل مقدمي رعاية صحية مستقلين ومرخّصين.",
      ctaPrimary: "استشارة عبر واتساب",
      ctaSecondary: "استكشف الخدمات",
      waMessage: "مرحباً هيا بيوتي كير، أرغب بطلب استشارة.",
      ratingTitle: "على Google",
      ratingNote: "وفق بيانات الملف التجاري المعروضة حالياً على Google (3 مراجعات).",
      imageCaption: "إسطنبول، تركيا",
    },
    marquee: [
      "تجميل الأسنان",
      "جراحة التجميل",
      "تنسيق المرضى",
      "إسطنبول",
      "دعم الرحلة العلاجية",
      "رعاية المتابعة",
    ],
    services: {
      eyebrow: "ما نقوم بتنسيقه",
      heading: "رعاية منسّقة بامتياز.",
      sub: "تبدأ كل رحلة بتقييم من مقدم رعاية صحية مرخّص، يحدد العلاج الأنسب لك.",
      items: [
        {
          key: "dental",
          number: "01",
          title: "علاجات الأسنان",
          text: "تنسيق رعاية الأسنان مثل تجميل الابتسامة والقشور والزراعة. يُحدَّد العلاج المناسب فقط بعد التقييم من مقدم رعاية صحية مرخّص.",
        },
        {
          key: "aesthetic",
          number: "02",
          title: "جراحة التجميل",
          text: "تنسيق استشارات الجراحة التجميلية، مع خطة علاج يضعها مقدم رعاية صحية مرخّص بعد تقييم حالتك.",
        },
        {
          key: "coordination",
          number: "03",
          title: "تنسيق المرضى الدوليين",
          text: "تنظيم المواعيد، ودعم الترجمة، وتخطيط السفر والإقامة، والمتابعة المستمرة طوال فترة وجودك في إسطنبول.",
        },
      ],
    },
    steps: {
      eyebrow: "كيف نعمل",
      heading: "أربع خطوات مدروسة.",
      items: [
        {
          number: "01",
          title: "أرسل طلبك",
          text: "راسلنا عبر واتساب أو املأ نموذج الاستشارة، وأخبرنا بأسلوبك عمّا ترغب في تحسينه.",
        },
        {
          number: "02",
          title: "تنسيق التقييم الأولي",
          text: "ننسّق تقييماً مع مقدم رعاية صحية مرخّص يطّلع على حالتك ويوصي بالعلاج المناسب.",
        },
        {
          number: "03",
          title: "خطط لزيارة إسطنبول",
          text: "ننظّم مواعيدك ونساعدك في ترتيب سفرك، لتكون إقامتك في إسطنبول مريحة وسلسة.",
        },
        {
          number: "04",
          title: "المتابعة",
          text: "بعد العلاج، نبقى نقطة تواصلك لتنسيق المتابعة وإرشادات ما بعد الرعاية.",
        },
      ],
    },
    reviews: {
      eyebrow: "آراء Google",
      heading: "ماذا يقول ضيوفنا.",
      note: "تقييم 5.0 من 3 مراجعات، كما يظهر في بيانات الملف التجاري المعروضة حالياً على Google.",
      cardLabel: "مراجعة Google",
      reviewsWord: "مراجعات",
    },
    results: {
      eyebrow: "نتائج حقيقية",
      heading: "قبل وبعد.",
      sub: "صور تشاركها «هيا بيوتي كير» من رحلات حقيقية لضيوفنا.",
      caption: "قبل وبعد",
    },
    faq: {
      eyebrow: "قبل السفر",
      heading: "إجابات عن أسئلتك.",
      sub: "أكثر ما يسأل عنه ضيوفنا قبل التخطيط لرحلتهم إلى إسطنبول.",
      cta: "اسألنا عبر واتساب",
      items: [
        {
          q: "كيف أبدأ رحلتي؟",
          a: "راسلنا عبر واتساب أو املأ نموذج الاستشارة. نرد عليك شخصياً، نستمع لما ترغب في تحسينه، ونشرح لك الخطوات التالية.",
        },
        {
          q: "من الذي يقدّم العلاجات؟",
          a: "تُقدَّم جميع العلاجات من قِبل مقدمي رعاية صحية مستقلين ومرخّصين. نحن ننسّق رحلتك، ويُحدَّد العلاج المناسب فقط بعد تقييم مقدم الرعاية لحالتك.",
        },
        {
          q: "هل تساعدون في السفر والإقامة؟",
          a: "نعم. ننظّم مواعيدك ونساعدك في ترتيب السفر والإقامة، لتكون إقامتك في إسطنبول مريحة وسلسة.",
        },
        {
          q: "ما اللغات التي تدعمونها؟",
          a: "ننسّق بالعربية والإنجليزية، ونوفر دعم الترجمة طوال زيارتك.",
        },
        {
          q: "متى أحصل على السعر؟",
          a: "بعد أن يقيّم مقدم الرعاية الصحية المرخّص حالتك ويوصي بخطة العلاج، نشاركك عرض سعر واضحاً قبل أي التزام بالسفر.",
        },
        {
          q: "ماذا يحدث بعد العلاج؟",
          a: "نبقى نقطة تواصلك بعد العلاج، وننسّق مواعيد المتابعة وإرشادات ما بعد الرعاية.",
        },
      ],
    },
    istanbul: {
      eyebrow: "الوجهة",
      heading: "إسطنبول، بين قارتين.",
      copy: "تكتمل رحلتك في واحدة من أكثر مدن العالم سحراً — البوسفور عند الغروب، وقرون من التاريخ، وضيافة تحوّل رحلة العلاج إلى تجربة لا تُنسى.",
      cta: "ابدأ التخطيط",
      waMessage: "مرحباً هيا بيوتي كير، أرغب ببدء التخطيط لزيارتي إلى إسطنبول.",
    },
    form: {
      eyebrow: "الاستشارة",
      heading: "ابدأ بمحادثة.",
      copy: "شاركنا بعض التفاصيل وسنفتح محادثة واتساب برسالة جاهزة — دون حسابات أو انتظار.",
      callLabel: "تفضّل التحدث أولاً؟",
      labels: {
        name: "الاسم الكامل",
        country: "الدولة",
        phone: "رقم الهاتف / واتساب",
        service: "الخدمة المطلوبة",
        notes: "ملاحظات (اختياري)",
      },
      placeholders: {
        name: "اسمك الكامل",
        country: "مثال: الأردن",
        phone: "+00 000 000 00 00",
        service: "اختر الخدمة",
        notes: "أي شيء تود إخبارنا به",
      },
      serviceOptions: ["علاجات الأسنان", "جراحة التجميل", "أخرى"],
      consent: "أوافق على أن تتواصل معي «هيا بيوتي كير» عبر واتساب بخصوص استفساري.",
      sensitiveNote:
        "يرجى تجنّب مشاركة معلومات طبية شديدة الحساسية عبر القنوات غير الآمنة؛ سيتم طلب التفاصيل الطبية لاحقاً عبر قناة آمنة.",
      submit: "إرسال عبر واتساب",
      toast: "جارٍ فتح واتساب برسالتك…",
      requiredNote: "يرجى استكمال الحقول المطلوبة والموافقة.",
      messageIntro: "مرحباً هيا بيوتي كير، أرغب بطلب استشارة.",
    },
    footer: {
      blurb: "تنسيق المرضى الدوليين لعلاجات الأسنان وجراحة التجميل في إسطنبول، تركيا.",
      contactHeading: "تواصل",
      legalHeading: "قانوني",
      location: "إسطنبول، تركيا",
      privacy: "سياسة الخصوصية",
      cookies: "سياسة ملفات تعريف الارتباط",
      policies: {
        privacy: {
          title: "سياسة الخصوصية",
          body: "نجمع فقط البيانات التي تختار مشاركتها عبر نموذج الاستشارة أو واتساب — مثل الاسم والدولة ورقم الهاتف — ونستخدمها حصراً للرد على استفسارك وتنسيق رحلتك. إرسال النموذج يفتح واتساب مباشرة في متصفحك، ولا تُخزَّن أي بيانات على خوادمنا. لا نبيع بياناتك الشخصية إطلاقاً.",
        },
        cookies: {
          title: "سياسة ملفات تعريف الارتباط",
          body: "لا يستخدم هذا الموقع أي ملفات تعريف ارتباط للتتبع بشكل افتراضي. تبقى أدوات التحليلات (Google Analytics وMeta Pixel) معطّلة حتى يتم توفير معرّفات القياس، وتعمل جميع وظائف الموقع الأساسية دون ملفات تعريف ارتباط.",
        },
      },
      rights: "جميع الحقوق محفوظة.",
    },
  },
};
